import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { FC } from 'react'
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import { AuthProvider } from './contexts/auth-context.tsx'
import { ProtectedRoute } from './components/protected-route.tsx'
import { ClientsPage } from './pages/clients-page/clients-page.tsx'
import { ClientPage } from './pages/client-page/client-page.tsx'
import { DashboardPage } from './pages/dashboard-page/dashboard-page.tsx'
import { ItemsPage } from './pages/items-page/items-page.tsx'
import { ProjectsPage } from './pages/projects-page/projects-page.tsx'
import { ClientProjectPage } from './pages/client-project-page/client-project-page.tsx'
import { SettingsPage } from './pages/settings-page/settings-page.tsx'
import { LoginPage } from './pages/login-page/login-page.tsx'

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
})

export const App: FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<ProtectedRoute />}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="clients" element={<ClientsPage />} />
              <Route path="clients/:clientId" element={<ClientPage />} />
              <Route path="clients/:clientId/projects/:projectId" element={<ClientProjectPage />} />
              <Route path="projects" element={<ProjectsPage />} />
              <Route path="items" element={<ItemsPage />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  )
}
